import React from 'react';
import { Slider as SliderSingleValue } from './Single';
import { Slider as SliderDoubleValues } from './Double';
import { collectPackageInfo } from '../../collectPackageInfo';
collectPackageInfo('Slider/Slider');

var isSingleValueProps = function isSingleValueProps(props) {
  return typeof props.value === 'number';
};
/**
 * Слайдер позволяет определить числовое значение в пределах указанного промежутка.
 * Можно указать два значения.
 * Только для приложения Салют.
 */


export var SliderCore = function SliderCore(props) {
  if (isSingleValueProps(props)) {
    return /*#__PURE__*/React.createElement(SliderSingleValue, props);
  }

  return /*#__PURE__*/React.createElement(SliderDoubleValues, props);
};